import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./style.scss";

import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from "@mui/material";
import LogoPng from "../../assets/images/logo.svg";

const pages = [
  { title: "eBooks", path: "/" },
  // { title: "Author", path: "/author" },
  // { title: "Discourses", path: "/discourses" },
  { title: "Orientation", path: "/orientation" },
  { title: "Translations", path: "/translations" },
  { title: "Reprints", path: "/reprints" },
  { title: "About", path: "/about" },
];

function Navbar({ window }) {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };
  const getActiveLinkClassName = ({ isActive, isPending }) =>
    isActive ? "active" : isPending ? "pending" : "navLinkText";

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center", backgroundColor: "#552B13", height: "100%" }}
    >
      <img src={LogoPng} alt="Gosingārāma" style={{ height: 80, width: 108 }} />
      <Divider />
      <List>
        {pages.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton className="mobile-nav">
              <NavLink
                to={item.path}
                key={item.path}
                className={getActiveLinkClassName}
              >
                {item.title}
              </NavLink>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <AppBar
        // position="fixed"
        style={{ borderBottom: "1px solid #7D6514", paddingTop: 5 }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <img
              src={LogoPng}
              alt="Gosingārāma"
              style={{ height: 80, width: 108 }}
            />
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", lg: "flex" },
                fontWeight: "700",
                textTransform: "uppercase",
                letterSpacing: ".3rem",
                // color: '#7D6514',
                color: " #877439;",
                textDecoration: "none",
                fontFamily: "CormorantUnicase",
                borderRight: "2px solid #8a701a",
                fontSize: "15px",
                width: "200px",
              }}
            >
              Gosingārāma
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {pages.map((page) => (
                <div className="main-nav-list">
                  <NavLink
                    to={page.path}
                    key={page.path}
                    className={getActiveLinkClassName}
                  >
                    {page.title}
                  </NavLink>
                </div>
              ))}
            </Box>

            <Box sx={{ flexGrow: 0 }}>
              {/* <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip> */}
              {/* <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu> */}
            </Box>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{
                display: { xs: "flex", md: "none" },
                mr: 2,
                color: "#b08e29",
              }}
              // sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
        <div className="app-garland" />
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: "100%" },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
}
export default Navbar;
